
import axios from '../../utils/axios.js'

export const getCalibrationTip = (query) => axios.setAxiosGetPromise('calibrationTips/getCalibrationTip', query)

export const validDisabledUser = (query) => axios.setAxiosGetPromise('calibrationTips/validDisabledUser', query)

export const setDisabledUser = (body) => axios.setAxiosPostPromise('calibrationTips/setDisabledUser', body)



// WEBPACK FOOTER //
// ./src/services/system/calibrationTips.js